import React, { useState } from "react";
import "./Navbar.css";
import logo3 from "../../Assets/logo3.png";
import { FaPhoneAlt, FaBars, FaTimes, FaFacebookF, FaEnvelope  , FaYoutube, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      {/* Top Bar */}
      <div className="topbar">
        <div className="left-section">

          <span className="item">
            <MdEmail className="icon" /> namnadunammakkall@gmail.com
          </span>
        </div>

        <div className="right-section">
          <FaFacebookF className="social" />
          <FaYoutube className="social" />
          <FaInstagram className="social" />
          <FaEnvelope className="social"/> 
        </div>
      </div>

      {/* Navbar */}
      <div className="navbar-container">
        <img src={logo3} alt="logo" className="logo" />

        <div className="logo-name">
          <h1>
            <strong>OUR COUNTRY OUR PEOPLE</strong>
            <br />
            <strong>Foundation</strong>
          </h1>
        </div>

        {/* Desktop Menu */}
        <ul className="nav-menu">
          <li><Link to="/">HOME</Link></li>
          <li><Link to="/about">OUR STORY</Link></li>
          <li><Link to="/ourprojects">OUR PROJECTS</Link></li>
          <li><Link to="/gallery">GALLERY</Link></li>
          <li><Link to="/contact">CONTACT</Link></li>
          <button className="donate-btn">
            <Link to="/donate">DONATE NOW</Link>
          </button>
        </ul>

        {/* Mobile Hamburger */}
        <FaBars className="mobile-menu-icon" onClick={() => setDrawerOpen(true)} />
      </div>

      {/* Drawer Sidebar */}
      <div className={`mobile-drawer ${drawerOpen ? "open" : ""}`}>
        <FaTimes className="close-icon" onClick={() => setDrawerOpen(false)} />

        <ul>
          <li onClick={() => setDrawerOpen(false)}><Link to="/">HOME</Link></li>
          <li onClick={() => setDrawerOpen(false)}><Link to="/about">OUR STORY</Link></li>
          <li onClick={() => setDrawerOpen(false)}><Link to="/ourprojects">OUR PROJECTS</Link></li>
          <li onClick={() => setDrawerOpen(false)}><Link to="/gallery">GALLERY</Link></li>
          <li onClick={() => setDrawerOpen(false)}><Link to="/contact">CONTACT</Link></li>
          
        </ul>
      </div>
      <div className="mobile-donate-btn">
  <a href="/donate">DONATE NOW</a>
</div>
    </>
  );
};

export default Navbar;
